module.exports = __webpack_public_path__ + "static/Yuli-Rios-74c2a3ff4381dfca15f80590e8d2afef.png";